import { useNavigate } from 'react-router-dom';

export default function CTASection() {
  const navigate = useNavigate();

  return (
    <section className="py-24 bg-orange-500 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-orange-400/30 rounded-full -translate-y-1/2 translate-x-1/2" />
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-orange-600/30 rounded-full translate-y-1/2 -translate-x-1/2" />

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
          裝置出問題了嗎？
        </h2>
        <p className="text-orange-100 text-xl mb-10 max-w-xl mx-auto leading-relaxed">
          立即查詢維修報價，或直接帶機到店免費診斷。快速取件，讓您的裝置重獲新生。
        </p>
        <div className="flex flex-wrap items-center justify-center gap-4">
          <button
            onClick={() => navigate('/pricing')}
            className="px-10 py-4 bg-white text-orange-500 font-bold rounded-full hover:bg-orange-50 transition-colors whitespace-nowrap cursor-pointer text-lg"
          >
            立即查詢報價
          </button>
          <button
            onClick={() => navigate('/contact')}
            className="px-10 py-4 border-2 border-white/60 hover:border-white text-white font-bold rounded-full transition-colors whitespace-nowrap cursor-pointer text-lg"
          >
            聯絡我們
          </button>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-8 mt-12 text-white/80 text-sm">
          {['免費到店診斷', '多數當日完工', '3個月維修保固', '透明報價不二價'].map((t) => (
            <div key={t} className="flex items-center gap-2">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-check-line text-white" />
              </div>
              {t}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
